export const IcaoClass = {A:0, B:1, C:2, D:3, E:4, F:5, G:6, SUA:7 };
export const AirspaceType = {Other:0, Restricted:1, Danger:2, Prohibited:3, Cta:26};
export const ReferenceDatum = {Gnd: 0, Msl: 1, Fl: 2};

export default class Airspaces {

    static getReadableLimit(limit) {
        // if limit is 0 we display GND
        if (limit.value === 0) // NO ===
            return "GND";

        switch (limit.referenceDatum){
            case  ReferenceDatum.Fl:
                return `FL ${limit.value}`;
            case  ReferenceDatum.Gnd:
                return `${limit.value}ft AGL`;
            case  ReferenceDatum.Msl:
                return `${limit.value}ft MSL`;
            default:
                return limit.value;
        }
    }

    static getAirspaceName (airspace) {
        // Class
        switch(airspace.icaoClass) {
            case IcaoClass.A:
                return 'Class A';
            case IcaoClass.B:
                return 'Class B';
            case IcaoClass.C:
                return 'Class C';
            case IcaoClass.D:
                return 'Class D';
            default: // To avoid warning
                break;
        }

        // Danger / Prohibited / Restricted
        switch(airspace.type) {
            case AirspaceType.Danger:
                return 'Danger';
            case AirspaceType.Prohibited:
                return 'Prohibited';
            case AirspaceType.Restricted:
                return 'Restricted';
            default: // To avoid warning
                break;
        }

        return '';
    }
}